import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import apiClient from "@/modules/request.module.v2";

const useCompanyFromUrl = () => {
  const params = useParams();
  const urlAlias = params.company;

  return useQuery({
    enabled: !!urlAlias,
    queryKey: ["companyByAlias", urlAlias],
    queryFn: async () => {
      const response = await apiClient.get(`companies/${urlAlias}?alias=true`);
      window.companyId = response?.data?.id; // For making debugging faster
      return response;
    },
  });
};

export { useCompanyFromUrl };
